<template>

  <b-container style="flex: available">
    <b-container>
      <span style="margin-top: 10px"><br/></span>
      <b-container fluid>
        <b-container fluid>
          <b-card bg-variant="light">
            <b-container fluid>
              <b-form-group
                  label-cols-sm="4"
                  label="Company Name*:"
                  label-align-sm="left"
                  label-for="nested-street"
              >
                <b-form-input id="name" size="sm" v-model="name"
                              placeholder="Company Name" readonly="true"/>
              </b-form-group>

              <b-form-group
                  label-cols="4"
                  label-size="md"
                  label="Company Mailing Address*:"
                  label-align-sm="left"
                  label-for="nested-street"
              >
                <b-form-input id="address" size="sm" v-model="address"
                              placeholder="Company Address" readonly="true"/>
              </b-form-group>

              
            <b-form-group
                label-cols="4"
                label-cols-lg="4"
                label-size="md"
                label="County*:"
                label-for="input-sm">
              <b-form-select
                  v-model="county"
                  :options="countyMap">
              </b-form-select>
            </b-form-group>

              <b-form-group
                  label-cols="4"
                  label-cols-lg="4"
                  label-size="md"
                  label="Contact Name (Vineyard Manager/Management Company)*:"
                  label-for="input-sm">
                <b-form-input id="contactName" size="sm" v-model="contactName"
                              placeholder="Contact Name" readonly="true"/>
              </b-form-group>

              <b-form-group
                  label-cols="4"
                  label-cols-lg="4"
                  label-size="md"
                  label="Contact Title*: "
                  label-for="input-sm">
                <b-form-input id="contactTitle" size="sm" v-model="contactTitle"
                              placeholder="Contact Title" readonly="true"/>
              </b-form-group>

              <b-form-group
                  label-cols="4"
                  label-cols-lg="4"
                  label-size="md"
                  label="Contact Phone Number*:"
                  label-for="input-sm">
                <b-form-input id="contactTelephoneNumber" size="sm"
                              v-model="contactTelephoneNumber" placeholder="Contact Phone Number" readonly="true"/>
              </b-form-group>

              <b-form-group
                  label-cols="4"
                  label-cols-lg="4"
                  label-size="md"
                  label="Contact Email Address*:"
                  label-for="input-sm">
                <b-form-input id="input-sm" size="sm" v-model="contactEmail"
                              placeholder="Contact Email" readonly="true"/>
              </b-form-group>

              <b-form-group
                  label-cols="4"
                  label-cols-lg="4"
                  label-size="md"
                  label="Owner Name*: "
                  label-for="input-sm">
                <b-form-input id="input-sm" size="sm" v-model="ownerName"
                              placeholder="Owner Name" readonly="true"/>
              </b-form-group>

              <b-form-group
                  label-cols="4"
                  label-cols-lg="4"
                  label-size="md"
                  label="Owner Phone Number:"
                  label-for="input-sm">
                <b-form-input id="telephoneNumber" size="sm"
                              v-model="ownerTelephoneNumber" placeholder="Owner Telephone Number"
                              readonly="true"/>
              </b-form-group>

              <b-form-group
                  label-cols="4"
                  label-cols-lg="4"
                  label-size="md"
                  label="Owner Email Address*:"
                  label-for="input-sm">
                <b-form-input id="input-sm" size="sm" v-model="ownerEmail"
                              placeholder="Owner Email" readonly="true"/>
              </b-form-group>

              <b-form-group
                  label-cols="4"
                  label-cols-lg="4"
                  label-size="md"
                  label="Vineyard Name(s):"
                  label-for="input-sm">
                <b-form-input id="input-sm" size="sm" v-model="vineyardNames"
                              placeholder="Vineyard Names" readonly="true"/>
              </b-form-group>

              <b-form-group
                  label-cols="4"
                  label-cols-lg="4"
                  label-size="md"
                  label="Total Property Acres (for each non-contiguous parcel):"
                  label-for="input-sm">
                <b-form-input id="input-sm" size="sm" v-model="totalPropertyAcres"
                              placeholder="Total Property Acres" readonly="true"/>
              </b-form-group>
              <b-form-group
                  label-cols="4"
                  label-cols-lg="4"
                  label-size="md"
                  label="Vineyard Acres (for each non-contiguous parcel):"
                  label-for="input-sm">
                <b-form-input id="input-sm" size="sm" v-model="vineyardAcres"
                              placeholder="Vineyard Acres" readonly="true"/>
              </b-form-group>
              <b-form-group
                  label-cols="4"
                  label-cols-lg="4"
                  label-size="md"
                  label="Varieties Planted:"
                  label-for="input-sm">
                <b-form-input id="input-sm" size="sm" v-model="varietiesPlanted"
                              placeholder="Varieties Planted" readonly="true"/>
              </b-form-group>

              <b-form-group
                  label-cols="4"
                  label-cols-lg="4"
                  label-size="md"
                  label="Age Of Vines:"
                  label-for="input-sm">
                <b-form-input id="input-sm" size="sm" v-model="ageOfVines"
                              placeholder="Age of Vines" readonly="true"/>
              </b-form-group>

              <b-form-group
                  label-cols="4"
                  label-cols-lg="4"
                  label-size="md"
                  label="Are you planning a vineyard replant or new development within the next three years?:"
                  label-for="input-sm">
                <b-form-radio-group
                    v-model="imminentPlanting"
                    :options="yesNoOptions"
                    name="waterMeterTracking"
                    stacked
                    readonly="true"
                    onclick="javascript: return false;"
                />
              </b-form-group>

              <b-form-group
                  label-cols="4"
                  label-cols-lg="4"
                  label-size="md"
                  label="When was your last Irrigation Distribution Uniformity Assessment?:"
                  label-for="input-sm">
                <b-form-input v-model="lastIDUAssessment" name="lastIDUDatePicker"
                              style="width: 50%" placeholder="Last Irrigation Distribution Uniformity Assessment Date"
                              readonly="true" onclick="javascript: return false;"/>
              </b-form-group>

              <b-form-group
                  label-cols="4"
                  label-cols-lg="4"
                  label-size="md"
                  label="When did you last conduct soil testing?:"
                  label-for="input-sm">
                <b-form-input v-model="lastSoilTesting" name="lastSoilDatePicker"
                              style="width: 50%" placeholder="Last Soil Testing"
                              readonly="true" onclick="javascript: return false;"/>
              </b-form-group>

              <b-container fluid>

                <b-form-group label="Indicate current certifications (Check Relevant):">
                  <b-form-checkbox-group
                      v-model="certifications"
                      :options="certificationsOptions"
                      name="renewableEnergyInstalled"
                      stacked
                      readonly="true"
                      onclick="javascript: return false;"
                  />
                </b-form-group>

                <b-form-group label="Indicate current practices (Check Relevant):">
                  <b-form-checkbox-group
                      v-model="practices"
                      :options="practicesOptions"
                      name="renewableEnergyInstalled"
                      stacked
                      readonly="true"
                      onclick="javascript: return false;"
                  />
                </b-form-group>

              </b-container>

              <div class="button-holder">
                <b-row align-h="center">
                  <b-col cols="2"/>
                  <b-col cols="8">*Questions marked with an asterisk must be completed to submit the
                    form.
                  </b-col>
                  <b-col cols="2"/>
                </b-row>
              </div>


            </b-container>
            <div class="button-holder">
              <b-row align-h="center">
                <b-col cols="2">
                  <b-button :disabled="this.status === 'APPROVED'"
                            style="color: white; background-color: green" class="submit-button"
                            type="submit" @click="approve"
                            variant="primary">Approve
                  </b-button>
                </b-col>
                <b-col cols="2">
                  <b-button :disabled="this.status === 'APPROVED'"
                            style="color: white; background-color: green" class="submit-button"
                            type="submit" @click="reject"
                            variant="primary">Reject
                  </b-button>
                </b-col>
                <b-col cols="2">
                  <b-button style="color: white; background-color: green" class="cancel-button"
                            type="cancel" @click="cancel"
                            variant="primary">Cancel
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-container>
      </b-container>
    </b-container>
  </b-container>


</template>
<script>

import Datepicker from "vuejs-datepicker";

export default {
  props: {
    requestId: String,
  },
  components: {
    Datepicker
  },
  data() {
    return {
      id: this.requestId,
      status: '',
      errors: [],
      requiredText: "*Required",
      name: 'This is some shit',
      address: '',
      contactName: '',
      contactTitle: '',
      contactTelephoneNumber: '',
      contactEmail: '',
      ownerName: '',
      ownerEmail: '',
      ownerTelephoneNumber: '',
      vineyardNames: '',

      totalPropertyAcres: '',
      vineyardAcres: '',
      varietiesPlanted: '',
      ageOfVines: '',
      imminentPlanting: '',
      vineyardApns: '',
      lastIDUAssessment: '',
      lastSoilTesting: '',

      practices: [],
      practicesOptions: ["Have Carbon Farm Plan",
        "Compost",
        "Mulch",
        "Biochar",
        "Conservation tillage",
        "No-tillage",
        "Dry farming", "Livestock grazing",
        "Hedgerows", "Riparian/River/Ditch Restoration"],
      certifications: [],
      certificationsOptions: ["CCSW", "Organic", "Demeter Biodynamic"],
      yesNoOptions: ["Yes", "No"],
      county: null,
      countyMap: [{text: "", value: null}, 
                  {text: "Napa", value: "28"},
                  {text: "Lake", value: "17"},
                  {text: "Marin", value: "21"},
                  {text: "Mendocino", value: "23"}, 
                  {text: "Sonoma", value: "49"}, 
                  {text: "Solano", value: "48"}],
    }
  },
  mounted() {
    let self = this;
    this.$http.get("/account/vineyard/request/" + this.id)
        .then(result => {
              let response = result.data;
              self.name = response.name;
              self.address = response.address;
              self.contactName = response.contactName;
              self.contactTitle = response.contactTitle;
              self.contactTelephoneNumber = response.contactTelephoneNumber;
              self.contactEmail = response.contactEmail;
              self.ownerName = response.ownerName;
              self.ownerEmail = response.ownerEmail;
              self.ownerTelephoneNumber = response.ownerTelephoneNumber;
              self.vineyardNames = response.vineyardNames;
              self.totalPropertyAcres = response.totalPropertyAcres;
              self.vineyardAcres = response.vineyardAcres;
              self.varietiesPlanted = response.varietiesPlanted;
              self.ageOfVines = response.ageOfVines;
              self.imminentPlanting = response.imminentPlanting;
              self.vineyardApns = response.vineyardApns;
              self.lastIDUAssessment = this.toDateString(response.lastIDUAssessment);
              self.lastSoilTesting = this.toDateString(response.lastSoilTesting);
              self.county = response.county;
              self.practices = response.practices;
              self.certifications = response.certifications;
              self.status = response.status;
              /*====================================================*/
              console.log(result.data);
              console.log("Positive Response")
            }
        )
  },

  methods: {
    toDateString: function (dateMilliseconds) {
      if (dateMilliseconds instanceof Number) {
        return new Date(dateMilliseconds).toLocaleDateString();
      }
      return '';
    },
    goToMyTeam: function () {
      console.log("Logging in.");
      this.$router.push({path: '/groups'});
    },
    goToAccountInfo: function () {
      console.log("Logging in.");
      this.$router.push({path: '/update-account-info'});
    },
    goToUpdatePassword: function () {
      console.log("Logging in.");
      this.$router.push({path: '/update-password'});
    },
    goToMySurvey: function () {
      console.log("Logging in.")
      this.$router.push({path: '/survey?surveyId=1'});
    },
    cancel: function () {
      this.$router.push({path: '/review-requests'});
    },
    approve: function () {
      let self = this;
      swal({
        title: "Approving...",
        text: "Please wait...",
        showConfirmButton: false,
        allowOutsideClick: false
      });
      this.$http.post('account/request/decision', {
        requestId: self.id,
        requestStatus: "APPROVED",
        accountType: "VINEYARD"
      }, {
        headers: {
          'content-type': 'application/json'
        }
      })
          .then(function (response) {
            console.log(response.data);
            swal({
              title: "Account Approved!",
              showConfirmButton: false,
              timer: 1000
            });
            self.$router.push('review-requests');
          })
          .catch(function (error) {
            console.log("Something went really wrong: ", error);
            swal({
              title: "Failed!",
              showConfirmButton: false,
              timer: 1000
            });
          });

    },
    reject: function () {
      this.$http.post('account/request/decision', {
        requestId: this.requestId,
        requestStatus: "DENIED",
        accountType: "VINEYARD"

      }, {
        headers: {
          'content-type': 'application/json'
        }
      })
          .then(function (response) {
            console.log(response.data);
          })
          .catch(function (error) {
            console.log("Something went really wrong: ", error);
          });
      this.$router.push('review-requests');
    }
  }
}
</script>
